import { useState, useRef, useEffect } from 'react';

/**
 * Custom hook for managing modal states and form states for new deployment creation
 * @param {Array} linkedFamilies - Array of linked families
 * @param {Array} releases - Array of releases
 * @returns {Object} modal state, form state, and handlers
 */
export function useModalState(linkedFamilies, releases) {
    // Modal state
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const overlayMouseDown = useRef(false);

    // Form states for creating new deployment
    const [newDepName, setNewDepName] = useState('');
    const [newDepFamilyId, setNewDepFamilyId] = useState('');
    const [newDepGuiVersionTag, setNewDepGuiVersionTag] = useState('');
    const [newDepReleaseId, setNewDepReleaseId] = useState('');
    const [newDepPassword, setNewDepPassword] = useState('');
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [sharedDeployment, setSharedDeployment] = useState(null);

    // Set default family when linked families change
    useEffect(() => {
        if (linkedFamilies.length > 0 && !newDepFamilyId) {
            setNewDepFamilyId(linkedFamilies[0].id.toString());
        }
    }, [linkedFamilies, newDepFamilyId]);

    // Set default release when releases change
    useEffect(() => {
        if (releases.length > 0 && !newDepReleaseId) {
            setNewDepReleaseId(releases[0].id.toString());
        }
        if (!newDepGuiVersionTag) {
            setNewDepGuiVersionTag('1.0.0');
        }
    }, [releases, newDepReleaseId, newDepGuiVersionTag]);

    // Reset form when modal opens
    const handleOpenCreateModal = () => {
        setNewDepName('');
        if (linkedFamilies.length > 0) {
            setNewDepFamilyId(linkedFamilies[0].id.toString());
        }
        if (releases.length > 0) {
            setNewDepReleaseId(releases[0].id.toString());
        } else {
            setNewDepReleaseId('');
        }
        setNewDepGuiVersionTag('1.0.0');
        setNewDepPassword('');
        setIsCreateModalOpen(true);
    };

    // Close modal and reset form
    const handleCloseCreateModal = () => {
        setIsCreateModalOpen(false);
        setNewDepName('');
        setNewDepPassword('');
    };

    return {
        isCreateModalOpen,
        setIsCreateModalOpen,
        overlayMouseDown,
        newDepName,
        setNewDepName,
        newDepFamilyId,
        setNewDepFamilyId,
        newDepGuiVersionTag,
        setNewDepGuiVersionTag,
        newDepReleaseId,
        setNewDepReleaseId,
        newDepPassword,
        setNewDepPassword,
        isShareModalOpen,
        setIsShareModalOpen,
        sharedDeployment,
        setSharedDeployment,
        handleOpenCreateModal,
        handleCloseCreateModal
    };
}
